module.exports = __webpack_public_path__ + "static/media/adv-nick.be29dd2c.png";